import {
  GetSupportingDocsList,
  GetSupportingDocsListVariables,
} from "_graphql/queries/__generated__/GetSupportingDocsList";

import { getOfferSupportingDocuments } from "_graphql/visal/queries/offers";
import { useQuery } from "@apollo/client";

export const useOfferSupportingDocuments = (
  variables: GetSupportingDocsListVariables
) => {
  const { data, ...rest } = useQuery<
    GetSupportingDocsList,
    GetSupportingDocsListVariables
  >(getOfferSupportingDocuments, {
    variables: variables,
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-first",
  });

  return {
    documents: data?.getSupportingDocsList || [],
    ...rest,
  };
};
